// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-container {
    width: 100px; /* Adjust the width as needed */
    height: 100px; /* Adjust the height as needed */
    overflow: hidden;
  }
  
  .image-container img {
    width: 100%;
    height: auto;
  }
  .feedback-btn-container {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
  
  .feedback-btn {
    background-color: #4CAF50;
    color: white;
    font-size: 16px;
    padding: 12px 20px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    position: relative;
    z-index: 0;
  }
  
  .feedback-btn:hover {
    background-color: #45a049;
  }
  
  .feedback-btn:focus {
    outline: none;
  }
  
  /* Pulsing Animation Effect */
  .feedback-btn::before {
    content: '';
    position: absolute;
    top: -4px;
    left: -4px;
    right: -4px;
    bottom: -4px;
    border-radius: 12px;
    background: rgba(76, 175, 80, 0.3);
    animation: pulse 1.5s infinite ease-in-out;
    z-index: -1; /* Place the animation behind the button */
  }
  
  @keyframes pulse {
    0% {
      transform: scale(1);
      opacity: 0.5;
    }
    50% {
      transform: scale(1.1);
      opacity: 0.8;
    }
    100% {
      transform: scale(1);
      opacity: 0.5;
    }
  }
  
`, "",{"version":3,"sources":["webpack://./src/components/Firstpage.css"],"names":[],"mappings":"AAAA;IACI,YAAY,EAAE,+BAA+B;IAC7C,aAAa,EAAE,gCAAgC;IAC/C,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA,6BAA6B;EAC7B;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kCAAkC;IAClC,0CAA0C;IAC1C,WAAW,EAAE,0CAA0C;EACzD;;EAEA;IACE;MACE,mBAAmB;MACnB,YAAY;IACd;IACA;MACE,qBAAqB;MACrB,YAAY;IACd;IACA;MACE,mBAAmB;MACnB,YAAY;IACd;EACF","sourcesContent":[".image-container {\n    width: 100px; /* Adjust the width as needed */\n    height: 100px; /* Adjust the height as needed */\n    overflow: hidden;\n  }\n  \n  .image-container img {\n    width: 100%;\n    height: auto;\n  }\n  .feedback-btn-container {\n    display: flex;\n    justify-content: center;\n    margin-top: 30px;\n  }\n  \n  .feedback-btn {\n    background-color: #4CAF50;\n    color: white;\n    font-size: 16px;\n    padding: 12px 20px;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    position: relative;\n    z-index: 0;\n  }\n  \n  .feedback-btn:hover {\n    background-color: #45a049;\n  }\n  \n  .feedback-btn:focus {\n    outline: none;\n  }\n  \n  /* Pulsing Animation Effect */\n  .feedback-btn::before {\n    content: '';\n    position: absolute;\n    top: -4px;\n    left: -4px;\n    right: -4px;\n    bottom: -4px;\n    border-radius: 12px;\n    background: rgba(76, 175, 80, 0.3);\n    animation: pulse 1.5s infinite ease-in-out;\n    z-index: -1; /* Place the animation behind the button */\n  }\n  \n  @keyframes pulse {\n    0% {\n      transform: scale(1);\n      opacity: 0.5;\n    }\n    50% {\n      transform: scale(1.1);\n      opacity: 0.8;\n    }\n    100% {\n      transform: scale(1);\n      opacity: 0.5;\n    }\n  }\n  \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
